import React from 'react';
import { Flame, ChevronRight } from 'lucide-react';

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function initials(first, last) {
  return `${(first || '')[0] || ''}${(last || '')[0] || ''}`.toUpperCase() || '?';
}

function ScoreDot({ score }) {
  if (score == null) return <span style={{ color: '#ADB5BD' }}>—</span>;
  const color = score >= 8 ? '#DC3545' : score >= 6 ? '#F26522' : '#2E8B98';
  return <span style={{ color, fontWeight: 700 }}>{score}/10</span>;
}

export default function HotLeadsSection({ rows, count, isTeam, onSeeAll, onRowClick }) {
  const visible = (rows || []).slice(0, 5);

  if (!visible.length) {
    return (
      <div className="my-day-card">
        <SectionHeader count={count} onSeeAll={onSeeAll} />
        <p style={{ fontSize: 12, color: '#6C757D', margin: '12px 0 0', textAlign: 'center' }}>No hot leads right now.</p>
      </div>
    );
  }

  return (
    <div className="my-day-card">
      <SectionHeader count={count} onSeeAll={onSeeAll} />
      <div className="responsive-scroll">
        <table style={{ width: '100%', minWidth: 320, borderCollapse: 'collapse', fontSize: 12, marginTop: 8 }}>
          <thead>
            <tr style={{ color: '#ADB5BD', fontWeight: 600 }}>
              <th style={{ ...th, textAlign: 'left' }}>Contact</th>
              <th style={th}>Score</th>
              <th style={th}>Stage</th>
              <th style={th}>Follow-up</th>
              {isTeam && <th style={th}>Owner</th>}
            </tr>
          </thead>
          <tbody>
            {visible.map(c => (
              <tr
                key={c.id}
                className={onRowClick ? 'my-day-row-clickable' : ''}
                onClick={onRowClick ? () => onRowClick(c) : undefined}
                tabIndex={onRowClick ? 0 : undefined}
                onKeyDown={onRowClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(c); } } : undefined}
                style={{ borderTop: '1px solid #F0F0F0' }}
              >
                <td style={td}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                    <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#FFEEF0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700, color: '#DC3545', flexShrink: 0 }}>
                      {initials(c.first_name, c.last_name)}
                    </div>
                    <span style={{ fontWeight: 500, color: '#212529' }}>{c.first_name} {c.last_name}</span>
                  </div>
                </td>
                <td style={{ ...td, textAlign: 'center' }}><ScoreDot score={c.patient_intent_score} /></td>
                <td style={{ ...td, textAlign: 'center' }}>
                  <span style={{ background: '#E8F4F8', color: '#2E8B98', padding: '2px 7px', borderRadius: 8, fontSize: 11, fontWeight: 600, textTransform: 'capitalize' }}>
                    {(c.pipeline_stage || 'new').replace(/_/g, ' ')}
                  </span>
                </td>
                <td style={{ ...td, textAlign: 'center', color: '#6C757D' }}>{fmtDate(c.next_follow_up_date)}</td>
                {isTeam && <td style={{ ...td, textAlign: 'center', color: '#6C757D' }}>{c.assignee_name || '—'}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {onSeeAll && <SeeAllLink onSeeAll={onSeeAll} />}
    </div>
  );
}

function SectionHeader({ count, onSeeAll }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <Flame size={15} color="#DC3545" />
        <span style={{ fontSize: 13, fontWeight: 700, color: '#212529' }}>Hot leads</span>
        {count > 0 && <span className="my-day-count-badge active">{count}</span>}
        {count === 0 && <span className="my-day-count-badge">0</span>}
      </div>
    </div>
  );
}

function SeeAllLink({ onSeeAll }) {
  return (
    <button onClick={onSeeAll} style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 10, background: 'none', border: 'none', color: '#2E8B98', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
      See all <ChevronRight size={13} />
    </button>
  );
}

const th = { padding: '4px 8px', fontWeight: 600, fontSize: 11, color: '#ADB5BD', textAlign: 'center' };
const td = { padding: '7px 8px', color: '#495057' };
